import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import FormularioComponent from "../formulario";
import InformacionContactoComponent from "../informacioContacto";
import EncabezadoComponent from "../../../utilerias/encabezado";
import $ from "jquery";
import "./styles.css";

const ContactoComponent = (props) => {
  const encabezado = () => {
    $(document).ready(function ($) {
      const encabezado = document.getElementById("encabezado-label");
      encabezado.style.textAlign = "center";
      encabezado.style.color = "#fff";
    });
  };
  encabezado();
  return (
    <Fragment>
      <Container className="contacto-container">
        <Row>
          <Col className="espacio-superior-contacto" md={12} lg={12}></Col>
        </Row>
        <Row>
          <Col md={12} lg={2}></Col>
          <Col md={12} lg={8}>
            <EncabezadoComponent
              componente={props.componente}
              select={false}
            ></EncabezadoComponent>
          </Col>
          <Col md={12} lg={2}></Col>
        </Row>
        <Row>
          <Col md={12} lg={6}>
            <FormularioComponent
              cambiarIdioma={props.cambiarIdioma}
            ></FormularioComponent>
          </Col>
          <Col md={12} lg={2}></Col>
          <Col md={12} lg={4} align="left">
            <InformacionContactoComponent
              cambiarIdioma={props.cambiarIdioma}
            ></InformacionContactoComponent>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

ContactoComponent.propTypes = {
  componente: PropTypes.string,
  cambiarIdioma: PropTypes.bool,
};

export default ContactoComponent;
